import { useState, useCallback } from 'react';

const usePersistedState = <T = Record<string, unknown>>(
  key: string,
  initialValue: T = {} as T
): [T, (newState: T) => void] => {
  const [persistedState, _setPersistedState] = useState<T>(() => {
    if (localStorage.getItem(key)) {
      return JSON.parse(localStorage.getItem(key) as string);
    }
    localStorage.setItem(key, JSON.stringify(initialValue));
    return initialValue;
  });

  const setPersistedStateWrapper = useCallback(
    (newState: T) => {
      localStorage.setItem(key, JSON.stringify(newState));
      _setPersistedState(newState);
    },
    [key]
  );

  return [persistedState, setPersistedStateWrapper];
};

export default usePersistedState;
